import script from "./CustomerLoadWait.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerLoadWait.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerLoadWait.vue?vue&type=style&index=0&id=00b189e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b189e7"]])

export default __exports__